import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { AssetContext } from "../../../AssetContextWrapper";
import { AssetRealEstate } from "../../../models/AssetDetail";
import { estateApi } from "../../../apis";

export enum Outcomes {
  yes = "Yes, there’s a mortgage that still needs to be paid off",
  no = "No, the home is fully paid off or was bought in cash",
  notSure = "I’m not sure",
  skip = "Skip",
}

export const HasMortgageScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate } = useAuthContext()
  const { assetsLoaded } = useContext(AssetContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const primaryRealEstate = activeEstate?.primaryRealEstate;
  const reAsset = primaryRealEstate?.detail as AssetRealEstate;

  useEffect(() => {
    if (assetsLoaded && !activeEstate?.primaryRealEstate) {
      currentScreen &&
        flow?.navigateToNext(currentScreen, Outcomes.skip, navigate, {
          replace: true,
        });
    }
  }, [assetsLoaded]);

  const handleComplete = async (hasMortgage: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    if (activeEstate && activeEstate?.primaryRealEstate?.detail) {
      (activeEstate.primaryRealEstate.detail as AssetRealEstate).has_mortgage =
        hasMortgage;
      try {
        await estateApi.saveAsset(primaryRealEstate);
      } catch (error) {
        throw new Error("could not save data");
      }
    }

    flow?.navigateToNext(currentScreen, hasMortgage, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Is there an existing mortgage on the home?"
      subTitle="In order to determine the correct type of Probate for the estate, we need to know whether or not the home was owned outright or had a remaining mortgage."
    >
      <RadioAndResponseForm
        initAnswer={reAsset?.has_mortgage?.toString() || undefined}
        answerLabel="Property mortgage"
        errorText="We need to know whether or not there is a mortgage on the home."
        options={[
          { value: Outcomes.yes },
          { value: Outcomes.no },
          { value: Outcomes.notSure },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
